import { useState } from "react"
import { rsaEncrypt, pubKey } from '@/utils/encrypt'
import { trialApi } from '@/http/apiList'
import { toast } from 'sonner';
export function useTrialForm() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    company: "",
    country: "",
    password: "",
    confirmPassword: "",
  })

  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    return emailRegex.test(email)
  }
  
  const validateName = (name) => {
    if (name.trim() > 100) {
      return false;
    }
    const nameRegex = /^[a-zA-Z]+$/
    return nameRegex.test(name)
  }

  const validateForm = () => {
    const newErrors = {}

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required"
    } else if (!validateName(formData.firstName)) {
      newErrors.firstName = "Invalid Input"
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required"
    } else if (!validateName(formData.firstName)) {
      newErrors.lastName = "Invalid Input"
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required"
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address"
    }
    
    if (!formData.company.trim()) {
      newErrors.company = "Company is required"
    }

    if (!formData.country) {
      newErrors.country = "Country is required"
    }

    if (!formData.password) {
      newErrors.password = "Password is required"
    } else if (formData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters"
    } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,20}$/.test(formData.password)) {
      newErrors.password = "Password must contain uppercase, lowercase and special characters"
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password"
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const updateField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }))
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }))
    }
  }

  const handleSubmit = async (onSuccess) => {
    if (!validateForm()) {
      return
    }

    setIsSubmitting(true)
    try {
      // Simulate API call
      const { firstName, lastName, email, company, country, password, confirmPassword } = formData;
      await trialApi.submitTrial({
        firstName: btoa(rsaEncrypt(firstName, pubKey)),
        lastName: btoa(rsaEncrypt(lastName, pubKey)),
        email: btoa(rsaEncrypt(email, pubKey)),
        company: btoa(rsaEncrypt(company, pubKey)),
        country: btoa(rsaEncrypt(country, pubKey)),
        password: btoa(rsaEncrypt(password, pubKey)),
        confirmPassword: btoa(rsaEncrypt(confirmPassword, pubKey)),

      });
      onSuccess?.()
    } catch (error) {
      toast.error(error.response.data.subMsg);
    } finally {
      setIsSubmitting(false)
    }
  }

  const resetForm = () => {
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      company: "",
      country: "",
      password: "",
      confirmPassword: "",
    })
    setErrors({})
  }

  return {
    formData,
    errors,
    isSubmitting,
    updateField,
    handleSubmit,
    resetForm,
  }
}
